import React, {useState} from 'react';
import Lottie from "react-lottie";
import animationData from "../../../assets/json/gift.json";

function ReferralSec({gotoReferral}){

    //animation

    const referralShow = ()=>{
        set_isStopped(false)
        setTimeout(()=>{
            gotoReferral()
        },1700)
    }

    const [isStopped,set_isStopped] = useState(true)
    const [isPaused,set_isPaused] = useState(false)

    const buttonStyle = {
        display: 'block',
        margin: '10px auto'
    };

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }

    };

    return(
        <div className="referral-show-row" onClick={()=>{
            referralShow()
        }}>
            <div className="ref-show-text">
                <span className="friends-referral-title" >معرفی به دوستان</span>
                <span className="friends-referral-desc">به دوستان معرفی کن تخفیف بگیر</span>
            </div>

            <div className="lottie-sec">
                <Lottie options={defaultOptions}
                        height={180}
                        width={180}
                        isStopped={isStopped}
                        isPaused={isPaused}/>
            </div>
        </div>
    )
}

export {ReferralSec}
